import { AppComponent } from './../../app.component';
import { Component } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { SharedModule } from '../../app.shared';
import { NgForm } from '@angular/forms';

import { User } from '../shared/User';
import { UserService } from '../shared/userService';
import { LocalStorage } from '../shared/localstorage.service';
import { systemsettingsserviceService } from '../shared/systemsettingsservice.service';


@Component({
    templateUrl: './login.component.html'
    // styleUrls: ['./login.component.css']
})
export class LoginComponent {
    username = '';
    password = '';
    message = '';
    userRole = '';
    tokenExpiration: Date;
    hours: number;
    screen = false;

    constructor(private userService: UserService, private localStorage: LocalStorage, private _router: Router) { }
    login(): void {
        this.screen = true;
        this.userService.getUser(this.username, this.password, '').then(user => {
            if (user.isAuthenticated) {
                this.tokenExpiration = new Date();
                this.hours = this.tokenExpiration.getHours();
                this.tokenExpiration.setHours(this.hours + 8);
                this.localStorage.setItem('userName', user.userName);
                this.localStorage.setItem('passWord', user.passWord);
                this.localStorage.setItem('token', user.token);
                this.localStorage.setItem('role', user.role);
                this.localStorage.setItem('isAuthenticated', 'true');
                this.localStorage.setItem('tokenExpires', this.tokenExpiration.toString());
                
                this.localStorage.setItem('currentState',user.currentState);
                
                this._router.navigate(['/home']);

            } else {
                this.password = '';
                this.message = 'Unable to log in successfully.';
                this.screen = false;
            }
        });
    }
}
